import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutGLAssignmentLookup extends Layout {
    sourceGlAssignment: DataSource;
    tableGLAssignment: Table;
}
